import { createReducer, on } from "@ngrx/store";
import { Area } from "../../models/area";
import { findAreaAct, loadAreaByIdAct, saveSuccessAreaAct, setViolationsAreaAct, updateSuccessAreaAct } from "./area.actions";

const area: Area = new Area();

export const areaReducer = createReducer(
    {
        area,
        violations: {},
        loading: true
    },
    /*CRUD CATALOG AREAS*/
    on(findAreaAct, (state, { id }) => ({
        area: state.area,
        violations: state.violations,
        loading: true
    })),
    on(loadAreaByIdAct, (state, { area }) => ({
        area: area,
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessAreaAct, (state, { areaNew }) => ({
        area: { ...areaNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessAreaAct, (state, { areaUpdated }) => ({
        area: { ...areaUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsAreaAct, (state, { areaForm, violations }) => ({
        area: { ...areaForm },
        violations: {...violations},
        loading: false
    })),
    /*CRUD CATALOG AREAS END*/
    )